export const FIELD_NAVIGATION_MAP = {
  // --- Pricing & Payments ---
  'pricing': {
    tab: { tabId: 'bookingLineItems', fieldLabel: 'Pricing Breakdown' },
    accordion: { accordionId: 'accordion-transactions', fieldLabel: 'Booking Transaction Details' }
  },
  'cost': {
    tab: { tabId: 'bookingLineItems', fieldLabel: 'Pricing Breakdown' },
    accordion: { accordionId: 'accordion-transactions', fieldLabel: 'Booking Transaction Details' }
  },
  'line items': {
    tab: { tabId: 'bookingLineItems', fieldLabel: 'Booking Line Items' },
    accordion: { accordionId: 'accordion-transactions', fieldLabel: 'Booking Transaction Details' }
  },
  'fare': {
    tab: { tabId: 'bookingLineItems', fieldLabel: 'Pricing Breakdown' },
    accordion: { accordionId: 'accordion-transactions', fieldLabel: 'Booking Transaction Details' }
  },
  'pending amount': {
    tab: { tabId: 'charges', fieldLabel: 'Payment Status' },
    accordion: { accordionId: 'accordion-transactions', fieldLabel: 'Booking Transaction Details' }
  },
  'pendingamount': {
    tab: { tabId: 'charges', fieldLabel: 'Payment Status' },
    accordion: { accordionId: 'accordion-transactions', fieldLabel: 'Booking Transaction Details' }
  },
  'security deposit': {
    tab: { tabId: 'charges', fieldLabel: 'Payment Information' },
    accordion: { accordionId: 'accordion-transactions', fieldLabel: 'Booking Transaction Details' }
  },
  'securitydeposit': {
    tab: { tabId: 'charges', fieldLabel: 'Payment Information' },
    accordion: { accordionId: 'accordion-transactions', fieldLabel: 'Booking Transaction Details' }
  },
  'deposit': {
    tab: { tabId: 'charges', fieldLabel: 'Payment Information' },
    accordion: { accordionId: 'accordion-transactions', fieldLabel: 'Booking Transaction Details' }
  },
  'payment': {
    tab: { tabId: 'charges', fieldLabel: 'Payment Status' },
    accordion: { accordionId: 'accordion-transactions', fieldLabel: 'Booking Transaction Details' }
  },
  'add transaction': {
    tab: { tabId: 'addtransations', fieldLabel: 'Add Transactions' },
    accordion: { accordionId: 'accordion-transactions', fieldLabel: 'Booking Transaction Details' }
  },

  // --- Vehicle Info ---
  'vehicle name': { tab: { tabId: 'vehicle', fieldLabel: 'Make & Model' }, accordion: { accordionId: 'accordion-alarms', fieldLabel: 'Alarm Events' } },
  'vehicle': { tab: { tabId: 'vehicle', fieldLabel: 'Make & Model' }, accordion: { accordionId: 'accordion-alarms', fieldLabel: 'Alarm Events' } },
  'license plate': { tab: { tabId: 'vehicle', fieldLabel: 'Registration Number' }, accordion: { accordionId: 'accordion-alarms', fieldLabel: 'Alarm Events' } },
  'registration': { tab: { tabId: 'vehicle', fieldLabel: 'Registration Number' }, accordion: { accordionId: 'accordion-alarms', fieldLabel: 'Alarm Events' } },

  // --- Modifications & Operations ---
  'cancel': { tab: { tabId: 'cancel', fieldLabel: 'Cancellation Info' }, accordion: { accordionId: 'accordion-cancellation', fieldLabel: 'Cancellation Details' } },
  'cancellation': { tab: { tabId: 'cancel', fieldLabel: 'Cancellation Info' }, accordion: { accordionId: 'accordion-cancellation', fieldLabel: 'Cancellation Details' } },
  'refund': { tab: { tabId: 'cancel', fieldLabel: 'Cancellation Info' }, accordion: { accordionId: 'accordion-cancellation', fieldLabel: 'Cancellation Details' } },
  'extension': { tab: { tabId: 'extension', fieldLabel: 'Extension' }, accordion: { accordionId: 'accordion-extension', fieldLabel: 'Extension Details' } },
  'extend': { tab: { tabId: 'extension', fieldLabel: 'Extension' }, accordion: { accordionId: 'accordion-extension', fieldLabel: 'Extension Details' } },
  'swap': { tab: { tabId: 'swapvehicle', fieldLabel: 'Swap Vehicle' }, accordion: { accordionId: 'accordion-swapping', fieldLabel: 'Swapping Details' } },
  'reschedule': { tab: { tabId: 'reschedulebooking', fieldLabel: 'Reschedule' }, accordion: { accordionId: 'accordion-reschedule', fieldLabel: 'Reschedule Details' } },

  // --- Customer, Agents & System ---
  'customer': { tab: { tabId: 'customer', fieldLabel: 'Customer' }, accordion: { accordionId: null, fieldLabel: 'Customer' } },
  'delivery agent': { tab: { tabId: 'assignagents', fieldLabel: 'Delivery Agent' }, accordion: { accordionId: null, fieldLabel: 'Delivery Agent' } },
  'trip': { tab: { tabId: 'trip', fieldLabel: 'Trip Details' }, accordion: { accordionId: null, fieldLabel: 'Trip Details' } },
  'images': { tab: { tabId: 'images', fieldLabel: 'Booking Images' }, accordion: { accordionId: null, fieldLabel: 'Booking Images' } },
  'timeline': { tab: { tabId: 'timeline', fieldLabel: 'Timeline' }, accordion: { accordionId: null, fieldLabel: 'Timeline' } },
  'comments': { tab: { tabId: 'bookingcomments', fieldLabel: 'Booking Comments' }, accordion: { accordionId: null, fieldLabel: 'Booking Comments' } }
};